import { useId } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import type { SwitchProps } from './types'

import * as S from './styles'

export const Switch = ({ name, label, disabled = false, ...rest }: SwitchProps) => {
  const { control } = useFormContext()

  const id = useId()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <S.SwitchContainer>
          <S.Switch
            checked={field.value || false}
            onChange={field.onChange}
            onBlur={field.onBlur}
            name={field.name}
            inputProps={{ id }}
            disabled={disabled}
            {...rest}
          />
          {label && <S.Label htmlFor={id}>{label}</S.Label>}
        </S.SwitchContainer>
      )}
    />
  )
}
